const langtrans={
      ddjxyp:["大救星云平台","Dajiuxing Cloud Platform"],
      yyqbjq:["有求必救，全球救援服务第一平台","No. 1 Platform for Global Assistance Service.Respond to Every Call for Help"],
      fggqqj:["覆盖全球救援范围","Global Coverage"],
      jyjgbp:["救援机构遍布全球，支持全球救援","Supported by Worldwide Assistance Service Network"],
      cczzzg:["操作更加便捷简洁","Easy to Operate"],
      bzhhlc:["标准化流程，减少冗余操作流程清晰简洁","Standardized Process, Reduced  Redundancy, Clear and Concise"],
      qcjylc:["全程救援流程透明化","Transparent Whole Service Process"],
      jyggcq:["救援过程全程线上节点透明化监管便捷，发现问题及时快捷处理","Transparent online time nodes for easy monitoring, problem discovering and solving."],
      fyggqx:["费用更清晰明了","Better Cost Management"],
      jgjycb:["机构救援成本管理便捷方便，可导出全年及月度账单，监管单位更清晰费用节点","Easier for cost management for assistance service companies where annual and monthly bills can be exported for clients to track all cost payments. "],
      pttccx:["平台创新服务","Innovation of Services of the Platform"],
      qqggdd:["星使服务 全球各地2000+名当地服务者作为星使为用户提供第一现场服务","individual service providers: over 2000 local individual service providers around the world providing first-scene assistances for users."],
      pttjy:["陪同就医","Accompanying Users to Hospital"],
      pttyhq:["陪同用户去指定医院","Going to designated hospitals with users to help with communication and comfort"],
      ffwgtt:["服务沟通安抚事宜","en_translated"],
      ddddxd:["当地向导","Local Guiding"],
      pttgwd:["陪同国外当地向导旅游事宜，按小时计费","Providing local guiding services with costs at an hourly rate  "],
      ddddjs:["当地接送机","Local Airport medical evacuation"],
      dddddd:["当地的华人帮你接送机","Airport medical evacuation offered by local Chinese who know their way around and are safer."],
      aqyssx:["安全又熟悉","en_translated"],
      pttba:["陪同报案","Accompanying to Police Station"],
      gwclll:["国外出了意外纠纷不要","Helping communicate with local police in case of accidents and disputes."],
      hh:["慌","en_translated"],
      jggxss:["叫个星使来帮忙报案和当地警察沟通无障碍","en_translated"],
      fyffw:["翻译服务","Interpretation Services"],
      ddddyy:["当地语言的陪同翻译","Helping with language interpretation for businesses, daily needs, and tours"],
      swfypt:["商务翻译，普通翻译","en_translated"],
      wddjyc:["五大救援场景","Five Assistance scenarios"],
      yljy:["医疗救援","Medical Assistance"],
      ccmzzy:["从门诊住院到转运服务，覆盖全流程","Cover all processes from outpatient, hospitalization to transferring services"],
      zhjy:["灾害救援","Hazzard Assistance"],
      ffsznn:["发生灾难，紧急启动救援","Start Assistance for emergency at occurrence of hazard "],
      zajy:["治安救援","Assistance for social security"],
      shkzaj:["社会治安救援，为社会治安献出力量","Participate in the Assistance to dedicate to social security"],
      dljy:["道路救援","Road Assistance"],
      dlpmdl:["道路抛锚、道路故障、一键救援","One key Assistance for getting stuck midway and road trouble "],
      lxhhxh:["旅行社","Travel agency"],
      bbfttx:["不同行业定制专属方案","Customization Solutions for Different Industries"],
      bxgs:["保险公司","Insurance company"],
      wwbxgs:["为保险公司提供救援服务","Provide Assistance service for insurance company"],
      ddjczk:["点击查看","Click to view"],
      wwlxhh:["为旅行机构的客户提供境外救援救助解决方案","Offer overseas Assistance solutions to customers in travel agency"],
      jyqojy:["景区景点","Tourist attractions"],
      wwjydd:["为景点景区提供景区救援方案","Render tourist attraction the Assistance plan"],
      zwqqy:["驻外企业","Chinese enterprise residing abroad"],
      wwzwqq:["为驻外企业提供整套园区解决方案","Provide the Chinese enterprise residing abroad a package of schemes for park"],
      jyjgdl:["救援机构登录成功","Your login Assistance organization is successful "],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","Your login failed for incorrect user name or password"],
      dlsbwz:["登录失败，未知错误","Your login failed for unknown reason"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/Index.vue.trans.js